module.exports = __webpack_public_path__ + "media/images/choose/calendar-de01581afd2972f850e4592aad967734.png";